import { IStaffJob } from "@/api";
import { useStaffJobById } from "@/common/AppConfigUtils";
import { black } from "@/common/theming";

import Tag from "../../Tag";

export const StaffJobTag = ({ staffJobId }: { staffJobId: IStaffJob["id"] | undefined }) => {
  const staffJob = useStaffJobById(staffJobId);

  if (!staffJob) return <i> no assigned Job </i>;

  return (
    <Tag
      variant="small"
      className="tag-staff-job"
      text={staffJob.name}
      sx={{
        fontSize: "12px",
        borderRadius: "4px",
        padding: "2px 4px",
        border: `1px solid ${black}`,
      }}
    />
  );
};
